const state = {
    height:0,
    width:0,
    title:'',
    componment:'',
    data:'',
    dialogVisible:false,
    fullscreen:false
};

const mutations = {
    modalConfig(state, data){
        state.componment=data.componment;
        state.height=data.height;
        state.width=data.width;
        state.title=data.title;
        state.data=data.data;
        state.fullscreen=data.fullscreen;
        state.dialogVisible=true;
        state.closeJudge=data.closeJudge;

    },
    titleChange(state,data){
        state.title=data.title;
    },
    modalClose(state){
        state.componment='';
        state.height=0;
        state.width=0;
        state.title='';
        state.dialogVisible=false;
    }
}

const actions = {

}

export default {
    state,
    mutations,
    actions
}
